//UI COMPONENTS
import AccountsSelector from "./ui/AccountsSelector/AccountsSelector";
import UserSelector from "./ui/UserSelector/UserSelector";
import InstrumentSelector from "./ui/InstrumentSelector/InstrumentSelector";

//STYLES
import styles from "./AuthHeader.module.scss";

const AuthHeader = () => {
  const { headerContainer, userContainer, divider } = styles;

  return (
    <div className={headerContainer}>
      <InstrumentSelector />
      <div className={userContainer}>
        <AccountsSelector />
        <div className={divider} />
        <UserSelector />
      </div>
    </div>
  );
};

export default AuthHeader;
